import RegistrationForm from "./registration-form";

export default RegistrationForm;